module.exports = __webpack_public_path__ + "img/定位目标受众.a03de522.png";